
import * as UI from './gameUI.js'
import { gsap } from "gsap";
import { balance, baseScore, getLastPendingBet, pattern, tempArray, turbo, typeOfWin, winningAmount } from './networkService.js';
import { clickFlag, resetFlags, revealPreviousFlags } from './flags.js';
import { resetPump } from './pump.js';
import { highlightWinFlags, pumpBurstMultiplierSet } from './results/showResults.js';
import { background, COMMENDATION, GAME_STATES, RESULTS, WINS } from './constants.js';
import { gameData, networkData, demoState } from './data.js';
import { sceneTransition, tweenScaleAppear } from './utility.js';
import { bigWin, delayedCalls, majorJackpot, megaWin, minorJackpot, normalWin, ultraWin } from './commendation.js';
import { setCommendationType } from './animations.js';
import { showLose } from './popups/loseScreen.js';
import { grandJackpot } from './commendation.js';
import { buyTickets } from './networkService.js';
import { playOff, playOn, playrip4 } from './soundManager.js';
import { hideAnticipationAnimation, hideGrandWinSpine, hideMajorWinSpine, hideMinorWinSpine, resetPanel, showGrandWin, showGrandWinSpine, showMajorWin, showMajorWinSpine, showMinorWin, showMinorWinSpine } from './jackpotPanel.js';
import { setupTutScroll } from './popups/tutorial.js';
import { pixiApp } from './initializePixi.js';
import { setupHistoryLeft, setupHistoryRight } from './popups/betHistory.js';


const tickerFunctions = (delta) => {
  if (!UI.uiCreated) return

  updateLoop(delta)
  if (gameData.tutScroll) {
    setupTutScroll(delta)
  } else if (gameData.ftueScroll) {
    UI.ftueScroll(delta)
  } else if (gameData.betHistoryLeft) {
    setupHistoryLeft(delta)
  } else if (gameData.betHistoryRight) {
    setupHistoryRight(delta)
  }
}

const startGameTicker = () => {
  pixiApp.app.ticker.add((delta) => tickerFunctions(delta))
}

const stopGameTicker = () => {

}


const initialSetup = () => {

}

const processResult = () => {
  gameData.gameState = GAME_STATES.SETUP_STATE

  const scratchResult = networkData.scratchResult
  let delayIncrease = 0

  if (demoState.isDemo) {
    gameData.multiplierVal = (Math.floor(Math.random() * 4) + 1).toString();
    if (networkData.scratchResult == 'won') calculateWin()
  }

  switch (typeOfWin() ?? networkData.winType) {
    case WINS.NORMAL:
      delayIncrease += 0
      break;

    case WINS.BIG:
      delayIncrease += 0
      break;

    case WINS.MEGA:
      delayIncrease += 6
      break;

    case WINS.ULTRA:
      delayIncrease += 17
      break;

    default:
      break;
  }

  if (scratchResult === RESULTS.WON) {
    const fullRange = Array.from({ length: 9 }, (_, i) => i);
    gameData.notScratched = fullRange.filter(num => !gameData.scratchIndex.includes(num));

    if (demoState.isDemo) {
      const temp = pattern() ?? networkData.allFlagValues
      const flagRemaining = getRemainingValues(temp, gameData.scratchedValues);
      revealPreviousFlags(gameData.notScratched, flagRemaining, false);
      setTimeout(() => {
        highlightWinFlags()
        pumpBurstMultiplierSet()
        changeFlagAlpha()
      }, 300)
    } else {
      highlightWinFlags()
      pumpBurstMultiplierSet()
      const flagRemaining = getRemainingValues(pattern(), gameData.scratchedValues);
      revealPreviousFlags(gameData.notScratched, flagRemaining, false);
      changeFlagAlpha()
    }

    setTimeout(() => {
      showWinnings();
      stopPulsating()
    }, 700);

  } else if (scratchResult === RESULTS.LOST) {
    pumpBurstMultiplierSet()

    setTimeout(() => {
      stopPulsating()
      if (networkData.jackpotMinorWin || networkData.jackpotMajorWin || networkData.jackpotGrandWin) {
        showJackpots()
      } else {
        showLose()
      }
    }, 3000)
  }
  else {
    gameData.autoPlayInProgress = false;
  }

}

const stopPulsating = () => {
  UI.banderitasCollection.forEach((item) => {
    gsap.killTweensOf(item.under.multiplierValue.scale)
    item.under.multiplierValue.scale.set(2.7)
  })
}

function changeFlagAlpha() {
  const patternValue = pattern() ?? networkData.allFlagValues
  let baseScoreValue = baseScore() ?? gameData.winNumber

  baseScoreValue = +baseScoreValue
  if (demoState.isDemo) {
    if (baseScoreValue == 10000) {
      gameData.winNumber = '10K'
    } else if (baseScoreValue == 1000) {
      gameData.winNumber = '1K'
    }

    UI.banderitasCollection.forEach((item, index) => {
      if (item.under.multiplierValue.text != gameData.winNumber) {
        item.under.alpha = 0.6
      }
    })
  }
  else {
    patternValue.forEach((scoreValue, index) => {
      if (scoreValue != baseScoreValue) {
        UI.banderitasCollection[index].under.alpha = 0.6
      }
    })
  }
}

function getRemainingValues(arr1, arr2) {
  const countOccurrences = (arr) => {
    return arr.reduce((acc, num) => {
      acc[num] = (acc[num] || 0) + 1;
      return acc;
    }, {});
  };

  const countArr1 = countOccurrences(arr1);
  const countArr2 = countOccurrences(arr2);

  let result = [];

  for (const num in countArr1) {
    const diff = countArr1[num] - (countArr2[num] || 0);
    if (diff > 0) {
      result.push(...Array(diff).fill(Number(num)));
    }
  }

  return result;
}

const calculateWin = () => {
  const calculatedAmount = gameData.winNumber * gameData.multiplierVal
  networkData.winAmount = calculatedAmount
  if (calculatedAmount < 5) {
    networkData.winType = 'NORMAL_WIN'
  } else if (calculatedAmount < 20) {
    networkData.winType = 'BIG_WIN'
  } else if (calculatedAmount < 100) {
    networkData.winType = 'MEGA_WIN'
  } else {
    networkData.winType = 'ULTRA_WIN'
  }
  gameData.balance = gameData.balance + calculatedAmount;
  UI.gameAssets.balanceAmount.text = formatBalance(gameData.balance)
  scaleBalance()
}

const scaleBalance = () => {
  UI.gameAssets.balanceAmount.style.fill = UI.gameAssets.balanceAmount.text != '0.00' ? '#FDD692' : '#FF0000';

  if (UI.gameAssets.balanceAmount.width > 260) {
    const scale = 260 / UI.gameAssets.balanceAmount.width;

    UI.gameAssets.balanceAmount.scale.set(scale)
  }
}

const showWinnings = () => {
  const winType = typeOfWin() ?? networkData.winType


  const delayedCall = gsap.delayedCall(2, () => {

    switch (winType) {
      case WINS.NORMAL:
        setCommendationType(COMMENDATION.NORMAL)
        normalWin(networkData.winAmount)
        delayedCalls.push(delayedCall)
        break;

      case WINS.BIG:
        setCommendationType(COMMENDATION.BIG)
        bigWin(networkData.winAmount)
        delayedCalls.push(delayedCall)
        break;

      case WINS.MEGA:
        setCommendationType(COMMENDATION.MEGA)
        megaWin(networkData.winAmount)
        delayedCalls.push(delayedCall)
        break;

      case WINS.ULTRA:
        setCommendationType(COMMENDATION.ULTRA)
        ultraWin(networkData.winAmount)
        delayedCalls.push(delayedCall)
        break;

      default:
        break;
    }

  })
}

const showJackpots = () => {
  if (networkData.jackpotMinorWin) {
    controlJackpotWinSpine(0, true);
    setCommendationType(COMMENDATION.MINOR);
    minorJackpot(networkData.jackpotMinorWinAmount);
  } else if (networkData.jackpotMajorWin) {
    controlJackpotWinSpine(0, false);
    controlJackpotWinSpine(1, true);
    setCommendationType(COMMENDATION.MAJOR);
    majorJackpot(networkData.jackpotMajorWinAmount)
  } else if (networkData.jackpotGrandWin) {
    controlJackpotWinSpine(1, false);
    controlJackpotWinSpine(2, true);
    setCommendationType(COMMENDATION.GRAND);
    grandJackpot(networkData.jackpotGrandWinAmount)
  }
}

const changeBackground = (mainAnimation, pig, chicken) => {
  const bg = UI.gameAssets.background;
  const bgPig = UI.gameAssets.bgPig;

  if (!bg || !bgPig) return;


  // gsap.to([bg, bgPig], { 
  //   alpha: 0.4,   
  //   duration: 0,
  //   ease: "power1.inOut",  
  // onComplete: () => {
  bg.state.setAnimation(0, mainAnimation, true);
  background.pig = pig;
  background.chickens = chicken;

  if (gameData.pigAndChickenDelay) {
    gameData.pigAndChickenDelay.kill();
    gameData.pigAndChickenDelay = null;
  }

  bgPig.state.setAnimation(0, background.pig, false);

  gsap.to([bg, bgPig], {
    alpha: 1,
    duration: 1,
    ease: "power1.in"
  });

  UI.pigChicken();
  // }
  // });
}

const resetFlagAndPump = async () => {
  gameData.flagInProgress = false;
  if (networkData.jackpot) resetPanel()
  networkData.jackpot = false;
  resetPump()
  resetFlags()

  if (gameData.bgPointer == 1) {
    changeBackground('bacolod_bg', 'bacolod_bg_pig', 'bacolod_bg_chicken')
    gameData.bgPointer = 2;
  } else if (gameData.bgPointer == 2) {
    changeBackground('baguio_bg', 'baguio_bg_pig', 'baguio_bg_chicken')
    gameData.bgPointer = 3;
  } else if (gameData.bgPointer == 3) {
    changeBackground('manila_bg', 'manila_bg_pig', 'manila_bg_chicken');
    gameData.bgPointer = 4;
  } else {
    changeBackground('main_bg', 'main_bg_pig', 'main_bg_chicken');
    gameData.bgPointer = 1;
  }

  networkData.scratchResult = null;
  gameData.showWinAmount = false;
  UI.gameAssets.winningsNumber.text = 0;
  gameData.scratchedValues = []
  gameData.gameState = GAME_STATES.IDLE;
  UI.gameAssets.dimmer.visible = false;
  UI.gameAssets.amazing.visible = false;
  UI.gameAssets.amazingBitmap.visible = false;
  UI.gameAssets.commendation.visible = false;

  if (demoState.isDemo) {
    gameData.demoGameCount = gameData.demoGameCount + 1;

    if (gameData.demoGameCount > gameData.numberOfGames) {
      gameData.demoGameCount = 1;
      gameData.ticketsRemaining = false;
    }
  }

  UI.banderitasCollection.forEach((item) => {
    item.under.multiplierValue.text = 0
  })
  await getLastPendingBet()
  gameData.autoPlayInProgress = false;


  if (gameData.turboPlay && networkData.dataPlaceBet) {
    turboPlayRound()
  }
  else if (gameData.autoPlay && networkData.dataPlaceBet) {
    autoPlayRound()
  } else {
    UI.gameAssets.menuGraphic.visible = false;
    UI.gameAssets.menu.interactive = true;
    UI.gameAssets.spineObj.map((item) => {
      item.interactive = true;
    })
  }

}

const resetGameSettings = (delay) => {
  gameData.scratchIndex = []
  networkData.allFlagValues = [];
  gameData.winGame = null;
  gameData.winNumber = 0

  gsap.delayedCall(delay, () => {
    UI.banderitasCollection.forEach((flag, i) => {
      const cb = i === UI.banderitasCollection.length - 1 ? resetFlagAndPump : () => { }
      sceneTransition(flag, 0.5, cb)
    })

  })
}

export const setBalance = () => {
  balanceFn(balance(), true)
  // const bal = balance()
  // if(typeof bal !== 'number' || isNaN(bal)) return

  // if(UI.gameAssets?.balanceText && bal)
  //     UI.gameAssets.balanceText.text = bal
  // else
  //     console.error(UI.gameAssets?.balanceText?.text)
}

export const setInitialBalance = () => {
  balanceFn(networkData?.dataWithJwt?.wallet?.balance)
}

export const setWinnings = () => {
  const winningAmt = winningAmount()
  if (typeof winningAmt !== 'number' || isNaN(winningAmt)) return

  if (UI.gameAssets?.winningsNumber)
    UI.gameAssets.winningsNumber.text = winningAmt
  else {

  }
  // console.error(UI.gameAssets?.winningsNumber?.text)
}

export const setUserName = () => {
  const userId = networkData?.dataWithJwt?.user?.userName
  if (typeof userId !== 'string') return

  if (UI.gameAssets?.nameText)
    UI.gameAssets.nameText.text = userId
  // else  
  //   console.error(UI.gameAssets?.nameText?.text)

}

const balanceFn = (bal, flag = false) => {
  if (typeof bal !== 'number' || isNaN(bal)) return

  if (flag && UI.gameAssets?.balanceText) {
    tweenScaleAppear(UI.gameAssets.balanceText, 1.5, () => {
      UI.gameAssets.balanceAmount.text = formatBalance(bal);
      scaleBalance()
    })
  }
  else if (UI.gameAssets?.balanceText) {

    UI.gameAssets.balanceAmount.text = formatBalance(bal)
    scaleBalance()
  }
  // else
  //     console.error(UI.gameAssets?.balanceText?.text)
}

function formatBalance(balance, toFixed = 2) {
  return Number(balance)
    .toFixed(toFixed)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const updateLoop = (delta) => {

}

const showCurrentGames = () => {

}

export const handleTickets = async () => {
  UI.gameAssets.playHitGraphic.interactive = false;
  const response = await buyTickets();


  if (gameData.turboPlay && networkData.dataPlaceBet) {
    turboPlayRound();
  } else if (gameData.autoPlay && networkData.dataPlaceBet) {
    autoPlayRound()
  }
}

export const changePlayButtonStateAndText = (currentButton, flag = false) => {
  currentButton.visible = true;

  if (flag) {
    UI.gameAssets.playHitGraphic.interactive = false;
    UI.gameAssets.playHitGraphic.cursor = "auto"

    UI.gameAssets.minusBtnBetDisable.visible = true;
    UI.gameAssets.plusBtnBetDisable.visible = true;
    UI.gameAssets.betPlusHitGraphic.interactive = false;
    UI.gameAssets.betMinusHitGraphic.interactive = false;

    UI.gameAssets.plusBtnGameDisable.visible = true;
    UI.gameAssets.minusBtnGameDiable.visible = true;
    UI.gameAssets.gamesminusHitGraphic.interactive = false;
    UI.gameAssets.gamesPlusHitGraphic.interactive = false;

    UI.gameAssets.num1.alpha = 0;
    UI.gameAssets.text1.alpha = 0;
    UI.gameAssets.num2.alpha = 0;

    UI.gameAssets.num1.text = demoState.isDemo ? gameData.demoGameCount : networkData.currentTicket;
    UI.gameAssets.text1.text = "OF";
    UI.gameAssets.num2.text = demoState.isDemo ? gameData.numberOfGames : networkData.ticketsPurchased;

    if (UI.gameAssets.num1.text >= 10 && UI.gameAssets.num2.text >= 10) {

      UI.gameAssets.num1.fontSize = 16;
      UI.gameAssets.num2.fontSize = 16;
      UI.gameAssets.text1.fontSize = 8;
      UI.gameAssets.text1.x = -6
      UI.gameAssets.num2.x = 37
      UI.gameAssets.num1.x = -79
    }
    else if (UI.gameAssets.num2.text >= 10 && UI.gameAssets.num1.text < 10) {

      UI.gameAssets.num1.x = -94
      UI.gameAssets.num1.fontSize = 19;
      UI.gameAssets.num2.fontSize = 19;
      UI.gameAssets.text1.fontSize = 10
      UI.gameAssets.num2.x = 28
      UI.gameAssets.text1.x = -22
    } else {
      UI.gameAssets.num1.x = -92;
      UI.gameAssets.text1.x = 0;
      UI.gameAssets.num2.x = 76;
      UI.gameAssets.num1.fontSize = 21;
      UI.gameAssets.num2.fontSize = 21;
      UI.gameAssets.text1.fontSize = 14;
    }

    UI.gameAssets.num1.visible = UI.gameAssets.text1.visible = UI.gameAssets.num2.visible = true;
    UI.gameAssets.playButtonDown.visible = false;

    gsap.to([UI.gameAssets.num1, UI.gameAssets.text1, UI.gameAssets.num2], {
      alpha: 1,
      duration: 2,
      ease: "power2.out"
    });
    UI.gameAssets.betHitGraphic.interactive = false;
    UI.gameAssets.gameHitGraphic.interactive = false;
    if (!gameData.turboPlay) {
      UI.gameAssets.spineObj.forEach((item, i) => {
        item.interactive = true;
      });
    }

  } else {
    UI.gameAssets.minusBtnBetDisable.visible = false;
    UI.gameAssets.plusBtnBetDisable.visible = false;
    UI.gameAssets.betPlusHitGraphic.interactive = true;
    UI.gameAssets.betMinusHitGraphic.interactive = true;
    UI.gameAssets.playButtonHover.visible = false;

    UI.gameAssets.plusBtnGameDisable.visible = false;
    UI.gameAssets.minusBtnGameDiable.visible = false;
    UI.gameAssets.gamesminusHitGraphic.interactive = true;
    UI.gameAssets.gamesPlusHitGraphic.interactive = true;

    UI.gameAssets.num1.visible = UI.gameAssets.text1.visible = UI.gameAssets.num2.visible = false;
    UI.gameAssets.betHitGraphic.interactive = true;
    UI.gameAssets.gameHitGraphic.interactive = true;

    UI.gameAssets.autoPlaySelected.visible = false;
    UI.gameAssets.turboPlaySelected.visible = false;

    gameData.turboPlay = false;
    gameData.autoPlay = false;


    UI.gameAssets.spineObj.forEach((item, i) => {
      item.interactive = false;
    });

    UI.gameAssets.playHitGraphic.interactive = true;
    UI.gameAssets.playHitGraphic.cursor = "pointer"
    UI.gameAssets.totalBetAmount.text = gameData.numberOfGames * gameData.betAmount
  }
}

export const handleAutoPlay = () => {

  if (UI.gameAssets.autoPlaySelected.visible) {
    UI.gameAssets.autoPlaySelected.visible = false;
    UI.gameAssets.turboPlaySelected.visible = false;
    playOff(true)
    if (!gameData.autoPlayInProgress) {
      UI.gameAssets.menuGraphic.visible = false;
      UI.gameAssets.menu.interactive = true;

      UI.gameAssets.spineObj.forEach((item, i) => {
        item.interactive = !gameData.scratchIndex.includes(i);
      });
    }

    gameData.autoPlay = false;
    gameData.turboPlay = false;

  } else {
    playOn(true)
    UI.gameAssets.autoPlaySelected.visible = true;
    gameData.autoPlay = true;


    if (!gameData.autoPlayInProgress && networkData.dataPlaceBet && !gameData.flagInProgress) {
      autoPlayRound()
    }
  }
}

export const handleTurboPlay = () => {
  if (UI.gameAssets.turboPlaySelected.visible) {
    UI.gameAssets.turboPlaySelected.visible = false;
    UI.gameAssets.autoPlaySelected.visible = false;
    gameData.turboPlay = false;
    playOff(true)
    gameData.autoPlay = false;

    // if(!gameData.autoPlayInProgress){
    //   UI.gameAssets.spineObj.forEach((item, i) => {
    //     item.interactive = false; 
    //   });
    // }

  } else {
    UI.gameAssets.turboPlaySelected.visible = true;
    UI.gameAssets.autoPlaySelected.visible = true;
    gameData.turboPlay = true;
    gameData.autoPlay = true;
    playOn(true)

    if (!gameData.autoPlayInProgress && networkData.dataPlaceBet && !gameData.flagInProgress) {
      turboPlayRound();
    }
  }
}

const turboPlayRound = async () => {
  if (gameData.autoPlayInProgress) return;
  gameData.autoPlayInProgress = true;
  UI.gameAssets.menuGraphic.visible = true;
  UI.gameAssets.menu.interactive = false;

  UI.gameAssets.spineObj.map((item) => {
    item.interactive = false;
  })

  gameData.firstScratchDone = true;
  if (networkData.isJackpot) hideAnticipationAnimation()

  const fullRange = Array.from({ length: 9 }, (_, i) => i);
  const unscratchIndexes = fullRange.filter(num => !gameData.scratchIndex.includes(num));

  const flagRemaining = demoState.isDemo ? tempArray : getRemainingValues(networkData.allFlagValues, gameData.scratchedValues);

  stopPulsating()

  await turbo();

  if (networkData.turboData) {
    demoState.isDemo ? revealTurboFlagsCommon(unscratchIndexes, flagRemaining, true) : revealTurboFlagsCommon(unscratchIndexes, networkData.allFlagValues, true);

    if (demoState.isDemo) {
      gameData.multiplierVal = (Math.floor(Math.random() * 4) + 1).toString();
      if (networkData.scratchResult == RESULTS.WON) {
        calculateWin()
      }
    }
    if (networkData.scratchResult == RESULTS.LOST) {
      setTimeout(() => {
        pumpBurstMultiplierSet()
      }, 1200)

      setTimeout(() => {
        stopPulsating()
        if (networkData.jackpotMinorWin || networkData.jackpotMajorWin || networkData.jackpotGrandWin) {
          showJackpots()
        } else {
          showLose()
        }
      }, 3500)
    }
    else if (networkData.scratchResult == RESULTS.WON) {

      let delayIncrease = 0

      switch (typeOfWin() ?? networkData.winType) {
        case WINS.NORMAL:
          delayIncrease += 0
          break;

        case WINS.BIG:
          delayIncrease += 0
          break;

        case WINS.MEGA:
          delayIncrease += 6
          break;

        case WINS.ULTRA:
          delayIncrease += 16
          break;

        default:
          break;
      }

      setTimeout(() => {
        highlightWinFlags()
        changeFlagAlpha()
        playrip4(true)
      }, 1700)

      setTimeout(() => {
        pumpBurstMultiplierSet()
      }, 2200)

      setTimeout(() => {
        showWinnings();
        // if (!(networkData.jackpotMinorWin || networkData.jackpotMajorWin || networkData.jackpotGrandWin)) {          
        //   resetGameSettings(settings.gameResetDelay.won + delayIncrease, "processres2");
        // }
      }, 2700)
    }
  }

}

let playFlag = true;

const revealTurboFlagsCommon = (scratchedScoresIndexes, scratchedScore, shouldDelay = false, isDemo = false) => {
  if (!scratchedScoresIndexes?.length) return;

  let j = 0;
  playFlag = true;
  gameData.gameState = GAME_STATES.FLAG_ANIMATION;
  gameData.scratchDoneNumber = scratchedScoresIndexes.length - 1;

  Array.from({ length: 9 }, (_, i) => i).forEach((score, i) => {
    const delay = shouldDelay ? i * 200 : 0;

    setTimeout(() => {
      if (scratchedScoresIndexes.includes(score)) {
        UI.banderitasCollection[score].fallAnimation(
          UI.banderitasCollection[score],
          playFlag,
          0,
          false
        );
        playFlag = false;
        UI.banderitasCollection[score].under.visible = true;

        const index = demoState.isDemo ? j : i;
        let value = scratchedScore[index];
        let formattedValue = value.toString();

        // Set font
        if (value < 99) {
          UI.banderitasCollection[score].under.multiplierValue.fontName = 'font-bronze';
        } else if (value >= 99 && value <= 1000) {
          UI.banderitasCollection[score].under.multiplierValue.fontName = 'font-blue';
        } else {
          UI.banderitasCollection[score].under.multiplierValue.fontName = 'font-red';
        }

        // Format number as K if >= 1000
        if (value >= 1000) {
          formattedValue = (value / 1000).toFixed(0) + "K";
        }

        UI.banderitasCollection[score].under.multiplierValue.text = formattedValue;
        UI.banderitasCollection[score].multiplierAnimation(
          UI.banderitasCollection[score].under.multiplierValue,
          index === 0,
          !isDemo
        );

        if (demoState.isDemo) {
          j = j + 1;
        }
      }
    }, delay);
  });

  console.log('gameData.scratchDoneNumber', gameData.scratchDoneNumber);
};


const autoPlayRound = () => {
  console.log("INSIFIGHFIREHGIR", gameData.autoPlayInProgress);
  if (gameData.autoPlayInProgress) return;
  UI.gameAssets.menuGraphic.visible = true;
  UI.gameAssets.menu.interactive = false;
  gameData.autoPlayInProgress = true;
  let index = getUniqueIndex(gameData.scratchIndex);
  const spineObj = UI.gameAssets.spineObj[index]
  UI.gameAssets.spineObj.map((item) => {
    item.interactive = false;
  })

  clickFlag(spineObj)
}

const getUniqueIndex = (temp) => {
  const range = Array.from({ length: 9 }, (_, i) => i);
  const availableNumbers = range.filter(num => !temp.includes(num));

  if (availableNumbers.length === 0) return null;

  const randomIndex = Math.floor(Math.random() * availableNumbers.length);
  return availableNumbers[randomIndex];
}

const getNumbersOccurringTwice = (arr) => {
  const countObj = {};

  arr.forEach(num => {
    countObj[num] = (countObj[num] || 0) + 1;
  });

  return Object.keys(countObj)
    .filter(num => countObj[num] === 2)
    .map(Number);
};

const disableButtons = (flag) => {
  if (flag) {
    UI.gameAssets.playButtonDisable.visible = true;
    UI.gameAssets.playHitGraphic.interactive = false;

    UI.gameAssets.minusBtnBetDisable.visible = true;
    UI.gameAssets.plusBtnBetDisable.visible = true;
    UI.gameAssets.betPlusHitGraphic.interactive = false;
    UI.gameAssets.betMinusHitGraphic.interactive = false;

    UI.gameAssets.plusBtnGameDisable.visible = true;
    UI.gameAssets.minusBtnGameDiable.visible = true;
    UI.gameAssets.gamesminusHitGraphic.interactive = false;
    UI.gameAssets.gamesPlusHitGraphic.interactive = false;

    UI.gameAssets.betHitGraphic.interactive = false;
    UI.gameAssets.gameHitGraphic.interactive = false;

    UI.gameAssets.autoPlayDisable.visible = true;
    UI.gameAssets.turboPlayDisable.visible = true;

    UI.gameAssets.turboPlayHitGraphic.interactive = false;
    UI.gameAssets.autoPlayHitGraphic.interactive = false;

    UI.gameAssets.menuDisable.visible = true;
    UI.gameAssets.menu.interactive = false;

    UI.gameAssets.num1.visible = UI.gameAssets.text1.visible = UI.gameAssets.num2.visible = false;
  } else {
    UI.gameAssets.playHitGraphic.interactive = true;

    if (UI.gameAssets.playButtonDisable.visible && !networkData.ticketError) {
      UI.gameAssets.num1.visible = UI.gameAssets.text1.visible = UI.gameAssets.num2.visible = true;
    }
    UI.gameAssets.playButtonDisable.visible = false;

    if (networkData.ticketError) {
      UI.gameAssets.minusBtnBetDisable.visible = false;
      UI.gameAssets.plusBtnBetDisable.visible = false;
      UI.gameAssets.betPlusHitGraphic.interactive = true;
      UI.gameAssets.betMinusHitGraphic.interactive = true;
      UI.gameAssets.plusBtnGameDisable.visible = false;
      UI.gameAssets.minusBtnGameDiable.visible = false;
      UI.gameAssets.gamesminusHitGraphic.interactive = true;
      UI.gameAssets.gamesPlusHitGraphic.interactive = true;
      UI.gameAssets.betHitGraphic.interactive = true;
      UI.gameAssets.gameHitGraphic.interactive = true;
    }
    UI.gameAssets.playButtonDown.visible = false;
    UI.gameAssets.playButtonHover.visible = false;


    UI.gameAssets.autoPlayDisable.visible = false;
    UI.gameAssets.turboPlayDisable.visible = false;
    UI.gameAssets.turboPlayDown.visible = false;
    UI.gameAssets.autoPlayDown.visible = false;

    UI.gameAssets.turboPlayHitGraphic.interactive = true;
    UI.gameAssets.autoPlayHitGraphic.interactive = true;

    UI.gameAssets.menuDisable.visible = false;
    UI.gameAssets.menu.interactive = true;
  }
}

const showJackpotPanel = () => {
  if (UI.gameAssets.jackpotPanelContainer) {
    UI.gameAssets.jackpotPanelContainer.visible = true;
    UI.gameAssets.jackpotPanelContainer.alpha = 0;

    gsap.to(UI.gameAssets.jackpotPanelContainer, {
      alpha: 1,
      duration: 1.5
    });
    showGrandWin(networkData.grandCurrentJackpotValue)
    showMajorWin(networkData.majorCurrentJackpotValue)
    showMinorWin(networkData.minorCurrentJackpotValue)
  }
  else UI.gameAssets.jackpotPanelContainer.visible = false;
}

const controlJackpotWinSpine = (winTypeIndex, play) => {
  if (winTypeIndex === 2 && play)
    showGrandWinSpine();
  else
    hideGrandWinSpine();
  if (winTypeIndex === 1 && play)
    showMajorWinSpine();
  else
    hideMajorWinSpine();
  if (winTypeIndex === 0 && play)
    showMinorWinSpine();
  else
    hideMinorWinSpine();
}

const makeInitialSetupDisable = (flag) => {
  if (flag) {
    UI.gameAssets.betPanel.eventMode = 'none';
    UI.gameAssets.gamePanel.eventMode = 'none';
    UI.gameAssets.playButtonNormal.eventMode = 'none'
    UI.gameAssets.autoPlayHitGraphic.interactive = false;
    UI.gameAssets.turboPlayHitGraphic.interactive = false;
    UI.gameAssets.menu.interactive = false;

  } else {
    UI.gameAssets.betPanel.eventMode = 'passive';
    UI.gameAssets.gamePanel.eventMode = 'auto';
    UI.gameAssets.playButtonNormal.eventMode = 'auto'
    UI.gameAssets.autoPlayHitGraphic.interactive = true;
    UI.gameAssets.turboPlayHitGraphic.interactive = true;
    UI.gameAssets.menu.interactive = true;
  }
}


export {
  startGameTicker,
  stopGameTicker,
  processResult,
  resetGameSettings,
  showJackpots,
  balanceFn,
  autoPlayRound,
  getNumbersOccurringTwice,
  formatBalance,
  turboPlayRound,
  disableButtons,
  showJackpotPanel,
  controlJackpotWinSpine,
  makeInitialSetupDisable,
  scaleBalance
}
